import { useNavigate } from 'react-router-dom';
import { MemorialInCard } from './types';
import { useTranslation } from 'react-i18next';
import AvatarMemorial from '../../DLS/Avatar';
import { getFormattedDateToShow } from '../../utils';

const MemorialCards = ({ memorials }: { memorials: MemorialInCard[] }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-wrap justify-between">
        {memorials.map(
          ({ dateOfDeath, dieCity, dieCountry, firstName, id, image, lastName }, index) => (
            <div
              key={`card-${index}`}
              className={`mb-[16px] flex min-w-[278px] max-w-[278px] cursor-pointer rounded-[8px] border border-solid border-bg1 bg-white p-[24px]`}
              onClick={() => navigate(`/home/memorial/${id}?from=explore-memorials`)}
            >
              <div className="flex flex-col items-center">
                <AvatarMemorial
                  image={image}
                  initials={`${firstName[0]}${lastName[0]}`}
                  size={94}
                  shape="square"
                />
                <h3 className="m-[0px] mt-[16px]">{`${firstName} ${lastName}`}</h3>
                <p className="mt-[8px] text-center">
                  {t('memorial.dieIn', {
                    city: dieCity || dieCountry,
                    dateOfDeath: getFormattedDateToShow(dateOfDeath),
                  })}
                </p>
              </div>
            </div>
          )
        )}
        <div className="min-w-[326px]" />
      </div>
    </>
  );
};

export default MemorialCards;
